module.exports = __webpack_public_path__ + "img/W-9.e5ab68e8.jpg";